import { Component } from '@angular/core';
import { NiceSdkAuthenticationService } from '../../data/CXOne/sdk-auth/nice-sdk-authentication.service';
import { SdkAcdAgent } from '../../data/CXOne/sdk-acd/sdk-acd.service';
import { LoggerService } from '../../core/services/logger.service';
import { DynamicsService } from '../../data/Dynamics/dynamics.service';
// import { CXoneVoiceClient } from '@nice-devone/voice-sdk';
import { LoginService } from '../../core/services/login.service';
import { CXoneClient } from '@nice-devone/agent-sdk';
import { AgentSettings } from '@nice-devone/core-sdk';
import { UserInfo } from '@nice-devone/common-sdk';
import { CXoneVoiceContact } from '@nice-devone/acd-sdk';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { VoiceContactStatusAgent } from 'src/app/shared/enums/voice-contact-status-agent.enum';
import { IframeEnvironment } from 'src/app/core/services/util.service';
import { NiceSessionManagementService } from 'src/app/shared/services/nice-session-management/nice-session-management.service';
import { GenericModalService } from 'src/app/shared/services/generic-modal.service';

@Component({
  selector: 'app-consultores-seguros-pf',
  standalone: true,
  imports: [],
  templateUrl: './consultores-seguros-pf.component.html',
  styleUrl: './consultores-seguros-pf.component.css',
})
export class ConsultoresSegurosPfComponent {
  constructor(
    private niceSdkAuthService: NiceSdkAuthenticationService,
    private sdkAcdAgent: SdkAcdAgent,
    private logger: LoggerService,
    private dynamics: DynamicsService,
    private loginService: LoginService,
    private eventHandler: EventHandlerService,
    private genricModal: GenericModalService,
    private niceSessionManagementService: NiceSessionManagementService,
  ) {}

  async ngOnInit() {
    this.logger.info('Starting Seguros PF Component...');
    const centralId =
      localStorage.getItem('centralId') || 'consultores-seguros-pf';
    const authServiceType = localStorage.getItem('authServiceType') || 'nice';
    const authMode = localStorage.getItem('display_mode') || 'popup';
    const sessionIsExpired =
      this.niceSessionManagementService.checkNiceSessionExpiration();
    if (sessionIsExpired === false) {
      this.genricModal.createModal({
        title: 'Outra aba da Nice já está ativa',
        allowCloseModal: false,
        description:
          'Detectamos que você já possui uma aba da Nice aberta. Por favor, utilize a aba existente para continuar',
      });
      return;
    }

    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );
      if (isAuthenticated) {
        this.logger.info('User Authenticated.');
        await this.niceSdkAuthService.launchAgent();
        this.sdkAcdAgent.initialize();
        this.dynamics.initialize();
        this.niceSessionManagementService.updateNiceSession();

        this.sdkAcdAgent.agentState$.subscribe((agentState) => {
          this.logger.info('Agent State: ', agentState);
        });

        this.sdkAcdAgent.voiceContactUpdate$.subscribe(
          (voiceContact: CXoneVoiceContact) => {
            const status = voiceContact.status || '';
            const contactId = voiceContact.contactID || '';
            const contatoEvento = { id: contactId, status: status };
            let eventoProcessado = this.eventHandler.isProcessed(contatoEvento);
            this.logger.info(
              'Voice Contact status (',
              status,
              ') evento: ',
              voiceContact,
            );

            if (!eventoProcessado) {
              this.eventHandler.add(contatoEvento);
            }

            if (
              status === VoiceContactStatusAgent.DISCONNECTED &&
              eventoProcessado
            ) {
              this.eventHandler.remove(contatoEvento);
              this.InsertTimeLineDynamics(voiceContact);
            }
          },
        );

        window.addEventListener('message', (event) => {
          this.logger.info(event);
          if (event.data.messageType == 'onclicktoact') {
            this.HandleClickToActEvent(event);
            return;
          }
          return;
        });
      } else {
        this.logger.info('User not authenticated.');
      }
    } catch (error) {
      this.logger.error('Error on user athentication: ', error);
    }
  }

  private async getSkillIdOutboundCall(): Promise<number | null> {
    var skills = await this.sdkAcdAgent.cxoneAcd.getAgentSkills();

    this.logger.info('Skills retrieved: ', skills);

    for (const skill of skills) {
      if (skill.isOutbound === true && skill.typeId === 4) {
        return skill.skillId;
      }
    }
    return null;
  }

  private HandleClickToActEvent(event: any) {
    this.logger.info('Click event received from Dynamics. ', event);

    let clickToCallEvent = JSON.parse(event.data.messageData);
    let telephone = clickToCallEvent.value;
    let entityId = clickToCallEvent.entityId;

    this.logger.info(
      'Telephone received form dynamics: ' + telephone,
      'EntityId: ' + entityId,
    );

    if (
      IframeEnvironment[
        localStorage.getItem(
          'iframeEnvironment',
        ) as keyof typeof IframeEnvironment
      ] === IframeEnvironment.Dev
    ) {
      let telephoneManipulated = telephone.substring(3);
      this.logger.info('Telephone manipulated to: ' + telephoneManipulated);
      telephone = telephoneManipulated;
    }

    this.dialCallButtonClick(telephone);
  }

  private async dialCallButtonClick(phoneNumber: string) {
    var skillOutbound = await this.getSkillIdOutboundCall();
    this.logger.info('Outbound skill:', skillOutbound);

    if (skillOutbound == null) {
      this.logger.warn(
        'Cancelling dialing. Agent does not have an outbound voice skill.',
      );
      return;
    }

    var skillId = parseInt(skillOutbound.toString(), 10);

    this.logger.info('Dialing to ' + phoneNumber + ' from skillId ' + skillId);

    this.sdkAcdAgent.cxoneAcd.contactManager.voiceService
      .dialPhone({ skillId: skillId, phoneNumber: phoneNumber })
      .then((res) => {
        this.logger.info(
          'Dialled Given number and dial phone api successfully called: ',
          res,
        );
      })
      .catch((e) => {
        this.logger.error('Error: ', e);
      });
  }

  async getWebRtcServiceUrls() {
    const agentSettings =
      (await CXoneClient.instance.agentSetting.getAgentSettings()) as AgentSettings;
    const getUserInfo =
      (await CXoneClient.instance.cxoneUser.getUserDetails()) as UserInfo;
    if (!agentSettings && getUserInfo.icAgentId) {
      return;
    }

    return {
      agentId: getUserInfo.icAgentId,
      agentSettings: agentSettings,
      userInfo: getUserInfo,
    };
  }

  private async InsertTimeLineDynamics(event: CXoneVoiceContact) {
    if (typeof (window as any).Microsoft !== 'undefined') {
      let environment = JSON.parse(
        await (window as any).Microsoft.CIFramework.getEnvironment(),
      );
      let userId = environment.userId.slice(1, -1);
      let startTime = event.startTime;
      let endTime = new Date();
      let callDuration: number = Math.floor(
        Math.abs(endTime.getTime() - startTime.getTime()) / 60000,
      );

      const data = {
        subject: 'Chamada efetuada às: ' + new Date().toLocaleString(),
        phonenumber: event.dnis,
        directioncode: true,
        actualstart: startTime.toISOString(),
        actualend: endTime.toISOString(),
        'regardingobjectid_contact@odata.bind':
          '/contacts(' + environment.id + ')',
        statecode: 0,
        statuscode: 1,
        actualdurationminutes: callDuration,
        phonecall_activity_parties: [
          {
            'partyid_contact@odata.bind': '/systemusers(' + userId + ')',
            participationtypemask: 1,
          },
          {
            'partyid_contact@odata.bind': '/contacts(' + environment.id + ')',
            participationtypemask: 2,
          },
        ],
      };
      this.logger.info('Data sent to create record: ', JSON.stringify(data));

      try {
        await (window as any).Microsoft.CIFramework.createRecord(
          'phonecall',
          JSON.stringify(data),
        ).then(() => {
          this.logger.info(
            'Event sent to create record successfully in Dynamics: ',
          );
        });
      } catch (error: any) {
        this.logger.error('Error on sent create record', error);
      }
    } else {
      this.logger.warn('CIF is not ready yet.');
    }
  }
}
